import { Button, useWizard } from '@vestwell-frontend/ui';

import { FC, ReactNode, useCallback, useId } from 'react';

import { CreateGiftState } from '../config';

export const SignInLink: FC<{ children: ReactNode }> = props => {
  const ctx = useWizard<CreateGiftState>();
  const id = useId();

  const onClick = useCallback(() => {
    window.location.href = `/?postLoginPath=${window.location.origin}${ctx?.step?.url}`;
  }, []);

  return (
    <Button data-testid={id} onClick={onClick} variant='text'>
      {props.children}
    </Button>
  );
};
